import { lazy, Suspense } from 'react';
import { Route, BrowserRouter, Routes, Navigate } from 'react-router-dom';
import PrivateRoute from './PrivateRoute';
import {
  ROOT_URL,
  PROFILE_URL,
  BOOK_URL,
  BOOK_DETAIL_URL,
  AUTHOR_URL,
  AUTHOR_DETAIL_URL,
  REVIEW_URL,
  CATEGORY_URL,
  CATEGORY_DETAIL_URL,
  PUBLICATION_URL,
  PUBLICATION_DETAIL_URL,
  CHECKOUT_URL,
  ORDER_CONFIRMATION_URL,
  DASHBOARD_URL,
  ORDER_HISTORY_URL,
  ORDER_HISTORY_DETAIL_URL,
} from '../constants/routerUrl';

import Appbar from '../components/appbar/AppBar';
import TopBar from '../components/topbar/TopBar';
import NavDrawer from '../components/navdrawer/NavDrawer';
import SuspenseLoader from '../components/snippets/SuspenseLoader';
import ScrollToTop from '../components/snippets/ScrollToTop';
import AboutUs from '../components/common/AboutUs';
import Faq from '../components/common/Faq';
import Delivery from '../components/common/Delivery';
import Privacy from '../components/common/Privacy';
import Terms from '../components/common/Terms';
import MainLayout from '../components/common/MainLayout';
import { Box } from '@mui/material';

const Homepage = lazy(() => import('../components/Homepage/Homepage'));
const BookDetail = lazy(() => import('../components/BookDetail/BookDetail'));
const Author = lazy(() => import('../components/author/Author'));
const AuthorDetails = lazy(() => import('../components/author/AuthorDetails'));
const AllReviews = lazy(() => import('../components/review/AllReviews'));
const Category = lazy(() => import('../components/category/Category'));
const CategoryDetails = lazy(() => import('../components/category/CategoryDetails'));
const Publication = lazy(() => import('../components/publication/Publication'));
const PublicationDetails = lazy(() => import('../components/publication/PublicationDetails'));
const Checkout = lazy(() => import('../components/checkout/Checkout'));
const OrderConfirmation = lazy(() => import('../components/checkout/OrderConfirmation'));
const OrderTrack = lazy(() => import('../components/checkout/OrderTrack'));
const Dashboard = lazy(() => import('../components/dashboard/Dashboard'));
const OrderHistory = lazy(() => import('../components/orderHistory/OrderHistory'));
const OrderDetail = lazy(() => import('../components/orderHistory/OrderDetail'));
const Profile = lazy(() => import('../components/profile/Profile'));

const AppRouter = () => {
  return (
    <BrowserRouter>
      <Suspense fallback={<SuspenseLoader />}>
        <Appbar />
        <TopBar />
        <Box mt={9} />
        <NavDrawer />
        <ScrollToTop showBelow={250} />
        <MainLayout>
          <Routes>
            {/*Public Routes*/}
            <Route path={BOOK_DETAIL_URL} element={<BookDetail />} />
            <Route path={AUTHOR_URL} element={<Author />} />
            <Route path={AUTHOR_DETAIL_URL} element={<AuthorDetails />} />
            <Route path={BOOK_URL} element={<Homepage />} />
            <Route path={REVIEW_URL} element={<AllReviews />} />
            <Route path={ROOT_URL} element={<Navigate to={BOOK_URL} replace />} />
            <Route path={CATEGORY_URL} element={<Category />} />
            <Route path={CATEGORY_DETAIL_URL} element={<CategoryDetails />} />
            <Route path={PUBLICATION_URL} element={<Publication />} />
            <Route path={PUBLICATION_DETAIL_URL} element={<PublicationDetails />} />
            <Route path={CHECKOUT_URL} element={<Checkout />} />
            <Route path={ORDER_CONFIRMATION_URL} element={<OrderConfirmation />} />
            <Route path="/order-track" element={<OrderTrack />} />

            <Route path="/about" element={<AboutUs />} />
            <Route path="/faq" element={<Faq />} />
            <Route path="/delivery-service" element={<Delivery />} />
            <Route path="/privacy-policy" element={<Privacy />} />
            <Route path="/terms-and-conditions" element={<Terms />} />

            {/*Private Routes*/}
            <Route
              path={PROFILE_URL}
              element={
                <PrivateRoute>
                  <Profile />
                </PrivateRoute>
              }
            />
            <Route
              path={DASHBOARD_URL}
              element={
                <PrivateRoute>
                  <Dashboard />
                </PrivateRoute>
              }
            />
            <Route
              path={ORDER_HISTORY_URL}
              element={
                <PrivateRoute>
                  <OrderHistory />
                </PrivateRoute>
              }
            />
            <Route
              path={ORDER_HISTORY_DETAIL_URL}
              element={
                <PrivateRoute>
                  <OrderDetail />
                </PrivateRoute>
              }
            />
          </Routes>
        </MainLayout>
      </Suspense>
    </BrowserRouter>
  );
};

export default AppRouter;
